export const CHECKOUT_URL = 'https://renal-fr.impultienda.ar/checkout/'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/1AZvWWcHUp3872298QEKtQ/RENAL-FR.png'

export const KARITO_PHOTO =
  'https://cdn.magicpatterns.com/uploads/8EpB1w1UL2Fk5fdU7U8WZX/Dra_Karito_real.png'

export const stats = [
  { value: '+300', label: 'PAGES CLINIQUES' },
  { value: '6', label: 'VOLUMES SPÉCIALISÉS' },
  { value: '5', label: 'BONUS PREMIUM' },
  { value: '3 min', label: 'PAR ALGORITHME' },
  { value: '+1 000', label: 'MÉDECINS' },
]

export const beforeItems = [
  'Vous passez plus de temps à chercher des réponses qu’à prendre en charge le patient.',
  'Vous ouvrez KDIGO, UpToDate et plusieurs guides… et vous avez malgré tout encore des doutes.',
  'Vous ne savez pas si cette baisse du DFG est réellement préoccupante ou peut attendre.',
  'Vous arrêtez des médicaments par crainte, alors qu’ils pourraient protéger le rein.',
  'Vous orientez des patients « par précaution », sans savoir s’ils ont réellement besoin d’un néphrologue.',
]

export const afterItems = [
  'Vous ouvrez le bon algorithme et suivez une seule route clinique.',
  'Vous identifiez le stade rénal en quelques minutes, sans ambiguïté.',
  'Vous savez exactement quels examens demander et comment les interpréter.',
  'Vous savez quoi commencer, quoi maintenir et quoi arrêter.',
  'Vous savez quoi surveiller et à quel moment revoir le patient.',
  'Vous savez précisément quand orienter… et quand ce n’est pas nécessaire.',
]

export const painPoints = [
  {
    emoji: '😰',
    title: 'Vous voyez une créatinine élevée',
    body: 'Et vous ne savez pas si vous êtes face à une urgence ou à une anomalie qui peut attendre. Vous craignez de sous-estimer un patient qui perd de la fonction rénale… ou de surtraiter un résultat isolé.',
  },
  {
    emoji: '⏱️',
    title: 'Ce qui devrait prendre quelques minutes vous prend la moitié de la consultation',
    body: 'Vous passez d’un guide à l’autre à la recherche d’une réponse pratique pendant que le patient attend une décision.',
  },
  {
    emoji: '💊',
    title: 'Chaque médicament soulève une nouvelle question',
    body: 'Vous avez peur d’arrêter un médicament qui protège le rein… ou d’en maintenir un qui pourrait lui être nocif. IEC. ARA II. Metformine. iSGLT2.',
  },
  {
    emoji: '⚠️',
    title: 'Un potassium élevé change toute votre consultation',
    body: 'Vous ne savez pas si vous pouvez prendre le patient en charge en ambulatoire ou s’il doit être adressé immédiatement aux urgences.',
  },
  {
    emoji: '📉',
    title: 'Vous ne savez pas clairement quand il y a une véritable progression',
    body: 'Chaque nouveau bilan biologique semble soulever davantage de questions que de réponses.',
  },
  {
    emoji: '😔',
    title: 'Le patient part, mais le doute reste',
    body: 'Vous vous demandez pendant des heures si vous avez réellement pris la meilleure décision pour ce rein.',
  },
]

export const volumes = [
  {
    emoji: '📘',
    number: 'VOLUME I',
    title: 'Le Radar Rénal™',
    lead: 'Détectez la maladie rénale avant que tout le monde ne passe à côté.',
    body: 'Transformez toute anomalie de la créatinine ou du DFG en un diagnostic clair et une stadification précise grâce à des algorithmes visuels faciles à appliquer.',
  },
  {
    emoji: '📗',
    number: 'VOLUME II',
    title: 'Le Bouclier Néphroprotecteur™',
    lead: 'Protégez la fonction rénale sans arrêter les médicaments qui sauvent les reins.',
    body: 'Apprenez exactement quand débuter, maintenir, ajuster ou arrêter les IEC, les ARA II et les iSGLT2 avec une sécurité clinique maximale.',
  },
  {
    emoji: '📙',
    number: 'VOLUME III',
    title: 'Le Contrôleur du Milieu Intérieur™',
    lead: 'Maîtrisez le potassium, les diurétiques et l’équilibre acido-basique.',
    body: 'Résolvez les troubles métaboliques les plus fréquents grâce à des protocoles simples et prêts à être appliqués, sans jamais rester paralysé en consultation.',
  },
  {
    emoji: '📕',
    number: 'VOLUME IV',
    title: 'Le Triangle Cardio-Rénal-Métabolique™',
    lead: 'Gérez les comorbidités critiques sans prendre de décisions contradictoires.',
    body: 'Diabète, hypertension, insuffisance cardiaque et rein réunis dans un seul plan thérapeutique cohérent, avec des priorités claires pour chaque situation.',
  },
  {
    emoji: '📓',
    number: 'VOLUME V',
    title: 'Le Filtre Maître™',
    lead: 'Une consultation rapide pour le suivi du patient rénal.',
    body: 'Anémie, phosphore, calcium, vitamine D, acidose et critères de progression : quoi mesurer, quand le mesurer et quoi faire avec chaque résultat.',
  },
  {
    emoji: '📔',
    number: 'VOLUME VI',
    title: 'Outils et Checklists Cliniques™',
    lead: 'Tout le système transformé en fiches d’action imprimables.',
    body: 'Critères d’orientation, modèles de consultation, échelles et outils de vérification pour qu’aucune décision importante ne soit oubliée dans le dossier clinique.',
  },
]

export const deliveryItems = [
  {
    emoji: '📘',
    title: 'Les 6 Volumes Premium de Route Maladie Rénale™',
    body: 'Ce ne sont pas des livres à lire du début à la fin. Ce sont des outils cliniques conçus pour vous aider à décider en quelques minutes. Chaque volume résout une partie essentielle de la prise en charge rénale : du diagnostic initial au suivi à long terme.',
  },
  {
    emoji: '🧭',
    title: 'Algorithmes Cliniques de Décision™',
    body: 'Oubliez l’interprétation de centaines de pages de recommandations. Chaque algorithme répond à une seule question : « Lorsque je vois cela… que dois-je faire maintenant ? » Pas à pas. Sans doute.',
  },
  {
    emoji: '🛡️',
    title: 'Protocoles de Néphroprotection™',
    body: 'Apprenez quand protéger le rein… et quand une variation de la créatinine ne signifie pas que vous devez arrêter un traitement. Chaque protocole réduit l’incertitude clinique.',
  },
  {
    emoji: '⚡',
    title: 'Routes d’Action Immédiate™',
    body: 'Lorsque le bilan biologique revient anormal, vous n’aurez plus besoin d’ouvrir trois guides différents. Vous suivrez simplement la route : diagnostic → traitement → surveillance → orientation. Dans le bon ordre.',
  },
  {
    emoji: '📋',
    title: 'Checklists Intelligentes™',
    body: 'Chaque consultation suivra un processus clair : quoi demander, quels examens prescrire, quoi interpréter, quoi indiquer, quoi surveiller et quand revoir le patient.',
  },
]

export const bonuses = [
  {
    tag: 'BONUS N°1',
    value: '37 €',
    image:
      'https://cdn.magicpatterns.com/uploads/fVwNqZmPujogCRU1B5SpN7/BONUS_1_RENAL-FR.png',
    title: 'Protocole Hyperkaliémie Zéro™',
    lead: 'Ne restez plus jamais paralysé face à un potassium élevé.',
    body: 'Quand surveiller. Quand traiter. Quand ajuster les médicaments. Quand orienter immédiatement.',
  },
  {
    tag: 'BONUS N°2',
    value: '47 €',
    image:
      'https://cdn.magicpatterns.com/uploads/2mt5p3pYF1M73n11TwABw4/BONUS_2_RENAL-FR.png',
    title: 'Vade-mecum Rénal Intelligent™',
    lead: 'Les 100 médicaments que vous utilisez le plus, avec l’ajustement précis selon la fonction rénale.',
    body: 'Antibiotiques et antidiabétiques. Anticoagulants et antalgiques. Antihypertenseurs et bien plus encore. Organisé pour une consultation rapide.',
  },
  {
    tag: 'BONUS N°3',
    value: '27 €',
    image:
      'https://cdn.magicpatterns.com/uploads/vrnrdtAKVuYnSCpYPJQeBC/BONUS_3_RENAL-FR.png',
    title: 'Scripts de Consultation Rénale™',
    lead: 'Les réponses exactes aux questions les plus difficiles de vos patients.',
    body: 'Quoi dire. Comment le dire. Comment transmettre de la tranquillité. Des explications claires et simples.',
  },
  {
    tag: 'BONUS N°4',
    value: '47 €',
    image:
      'https://cdn.magicpatterns.com/uploads/eKJv5CecSfQbQHxmpV8Pm6/BONUS_4_RENAL-FR.png',
    title: 'Les 25 Erreurs Critiques™',
    lead: 'Les erreurs qui accélèrent la perte de la fonction rénale.',
    body: 'Les erreurs qui retardent le traitement. Les erreurs qui aggravent le pronostic. Les erreurs fréquentes, même chez les professionnels expérimentés. Et comment les éviter dès aujourd’hui.',
  },
  {
    tag: 'BONUS N°5',
    value: '37 €',
    image:
      'https://cdn.magicpatterns.com/uploads/99CY2pCjHEeVpvNeWNFuXs/BONUS_5_RENAL-FR.png',
    title: 'Checklist Maître de la Consultation Rénale™',
    lead: 'N’oubliez plus jamais un bilan, une indication ou un critère important.',
    body: 'Système imprimable. Consultation organisée et rapide. Rien n’est oublié. Prêt pour votre prochain patient.',
  },
]

export const offerRows = [
  { label: 'Route Maladie Rénale™ (6 Volumes Premium)', value: '97 €' },
  { label: 'Protocole Hyperkaliémie Zéro™', value: '37 €' },
  { label: 'Vade-mecum Rénal Intelligent™', value: '47 €' },
  { label: 'Scripts de Consultation Rénale™', value: '27 €' },
  { label: 'Les 25 Erreurs Critiques™', value: '47 €' },
  { label: 'Checklist Maître™', value: '37 €' },
]

export const testimonials = [
  {
    quote:
      'Avant, j’orientais certains patients par manque de confiance. Aujourd’hui, je sais exactement lesquels je peux prendre en charge et quand ils ont réellement besoin d’un néphrologue.',
    name: 'Dr Ricardo M.',
    country: 'Mexique 🇲🇽',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/c43a1f2a-9ea9-477f-9998-4b84ca712ed9.jpg',
  },
  {
    quote:
      'Le Bouclier Néphroprotecteur™ a complètement changé ma manière de prescrire. J’ai arrêté d’interrompre certains traitements par peur et j’ai commencé à mieux protéger la fonction rénale.',
    name: 'Dre Elena L.',
    country: 'Colombie 🇨🇴',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/89cef7da-bb63-4bae-8d12-707f13ec73c8.jpg',
  },
  {
    quote:
      'Le Vade-mecum Rénal Intelligent™ reste ouvert pendant mes consultations. Il me fait gagner énormément de temps.',
    name: 'Dr Esteban P.',
    country: 'Espagne 🇪🇸',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/fb223bf8-bcb3-45f9-81bf-16bd8765fc90.jpg',
  },
  {
    quote:
      'Les Scripts de Consultation Rénale™ m’ont aidée à expliquer la maladie rénale avec beaucoup plus d’assurance. Les patients comprennent mieux leur diagnostic.',
    name: 'Dre Mariana V.',
    country: 'Argentine 🇦🇷',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/4d9af0dc-0750-4540-b053-5d387a0671a7.jpg',
  },
]

export const faqs = [
  {
    q: 'Comment vais-je recevoir le matériel ?',
    a: 'Immédiatement après votre paiement, vous recevrez l’accès pour télécharger tous les volumes et les bonus. En quelques minutes, vous pourrez commencer à les utiliser.',
  },
  {
    q: 'Le système fonctionne-t-il dans tous les pays ?',
    a: 'Oui. Route Maladie Rénale™ est un matériel éducatif numérique conçu pour être consulté depuis n’importe quel pays. Son utilisation doit toujours s’adapter aux recommandations, réglementations et pratiques cliniques applicables dans votre contexte professionnel.',
  },
  {
    q: 'Les fichiers sont-ils téléchargeables ?',
    a: 'Oui. Après votre achat, vous aurez accès aux documents numériques inclus dans votre système et pourrez les consulter selon les modalités prévues dans votre accès.',
  },
  {
    q: 'Est-ce un paiement unique ?',
    a: 'Oui. Vous effectuez un seul paiement de 19 €. Aucun abonnement mensuel. Aucun paiement récurrent.',
  },
  {
    q: 'Dois-je être néphrologue ?',
    a: 'Non. Route Maladie Rénale™ a été conçue comme un outil éducatif pour les professionnels de santé confrontés à des patients présentant des problématiques rénales et souhaitant structurer davantage leur prise de décision clinique.',
  },
  {
    q: 'Dans quelle monnaie vais-je payer ?',
    a: 'Le prix de lancement pour le marché français est de 19 €. La conversion de devise est automatique : si vous payez depuis un autre pays, le montant est converti automatiquement dans votre monnaie locale au moment du paiement.',
  },
]

export const purchaseNotifications = [
  { name: 'Dr Andrés G.', place: 'Madrid, Espagne' },
  { name: 'Dra. Lucía R.', place: 'Bogotá, Colombie' },
  { name: 'Dr Javier P.', place: 'Mexico, Mexique' },
  { name: 'Dra. Camila S.', place: 'Buenos Aires, Argentine' },
  { name: 'Dr Miguel A.', place: 'Lima, Pérou' },
  { name: 'Dra. Paula V.', place: 'Santiago, Chili' },
  { name: 'Dr Ernesto C.', place: 'Quito, Équateur' },
  { name: 'Dra. Sofía M.', place: 'Montevideo, Uruguay' },
  { name: 'Dr Rafael T.', place: 'Barcelone, Espagne' },
  { name: 'Dra. Valentina O.', place: 'San José, Costa Rica' },
]
